export function getLoginStatusFromCookie(): boolean {
  if (typeof document === "undefined") return false;

  const match = document.cookie.split("; ").find((row) => row.startsWith("is_logged_in="));

  return match?.split("=")[1] === "true";
}
